import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { YtVideosRoutes } from "./Constants/routes";

const YoutubeVidz = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {YtVideosRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/ytVideos" />
      </Switch>
    </>
  );
};

export default YoutubeVidz;
